import api from './api'; // Importar a instância 'api' e setAuthToken
import { jwtDecode } from 'jwt-decode';

import { API_BASE_URL } from '../config/api';

export { API_BASE_URL };

// Remova esta linha se existir: axios.defaults.headers.common['Content-Type'] = 'application/json';

interface DecodedToken {
  user_id: number;
  username: string;
  role_id: number;
  deposito_id?: number;
  exp: number;
}

interface LoginResponse {
  message: string;
  user: {
    id: number;
    username: string;
    email: string;
    role_id: number;
    deposito_id?: number;
  };
  token: string;
}

interface RegisterResponse {
  message: string;
  user: {
    id: number;
    username: string;
    email: string;
    role_id: number;
    deposito_id?: number;
  };
}

const login = async (username: string, password: string): Promise<LoginResponse> => {
  const response = await api.post < LoginResponse > (`/login`, { // Usar 'api.post' e remover API_BASE_URL
    username,
    password,
  });

  if (response.data.token) {
    const decodedToken: DecodedToken = jwtDecode(response.data.token);
    localStorage.setItem(
      'user',
      JSON.stringify({
        ...response.data.user,
        role_id: decodedToken.role_id,
        deposito_id: decodedToken.deposito_id
      })
    );

    localStorage.setItem('token', response.data.token);
    // setAuthToken(response.data.token); // Removido, pois o interceptor em api.ts já trata isso
  }

  return response.data;
};

const register = async (
  username: string,
  email: string,
  password: string,
  role_id: number,
  deposito_id?: number // <- opcional
): Promise<RegisterResponse> => {
  const body: any = { username, email, password, role_id };

  if (deposito_id) {
    body.deposito_id = deposito_id;
  }

  const response = await api.post < RegisterResponse > (`/register`, body);
  return response.data;
};

const logout = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('selectedDeposito');
  // setAuthToken(null); // Removido, pois o interceptor em api.ts já trata isso
};

const getCurrentUser = () => {
  try {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    return JSON.parse(userStr);
  } catch {
    return null;
  }
};

const getToken = () => {
  return localStorage.getItem('token');
};

const authService = {
  login,
  register,
  logout,
  getCurrentUser,
  getToken,
  // setAuthToken, // Removido, pois a função não existe mais no api.ts e não é necessária aqui
};

export default authService;
